import { configureStore } from '@reduxjs/toolkit';
import gpuSlice from './slices/gpuSlice';
import taskSlice from './slices/taskSlice';
import monitoringSlice from './slices/monitoringSlice';
import alertSlice from './slices/alertSlice';
import settingsSlice from './slices/settingsSlice';
import authSlice from './slices/authSlice';
import taskVersionSlice from './slices/taskVersionSlice';
import taskMetadataSlice from './slices/taskMetadataSlice';
import taskWorkflowConfigSlice from './slices/taskWorkflowConfigSlice';

export const store = configureStore({
  reducer: {
    gpu: gpuSlice,
    task: taskSlice,
    monitoring: monitoringSlice,
    alert: alertSlice,
    settings: settingsSlice,
    auth: authSlice,
    taskVersion: taskVersionSlice,
    taskMetadata: taskMetadataSlice,
    taskWorkflowConfig: taskWorkflowConfigSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
